module.exports = __webpack_public_path__ + "static/media/laravel-logo.9f0623ff.svg";